<template>
  <el-dialog
    :visible.sync="showPwIframe"
    :lock-scroll="false"
    @closed="handleClose"
    top="20vh"
    append-to-body
  >
    <div class="d-loginframe">
      <button class="x" @click="handleClose"></button>
      <iframe
        class="pw-bg"
        v-if="showPwIframe"
        width="366"
        height="536"
        frameborder="0"
        scrolling="no"
        :src="baseInfo.wanmei_iframe_login_url"
        name="passport_login_iframe_parent"
        allowtransparency="true"
      ></iframe>
    </div>
  </el-dialog>
</template>

<script>
import { Dialog } from 'element-ui'
export default {
  data() {
    return {
      showPwIframe: true,
    }
  },
  computed: {
    baseInfo() {
      return this.$store.state.base_info
    },
  },
  components: {
    elDialog: Dialog,
  },
  methods: {
    handleClose() {
      this.$store.state.showPwIframe = false
    },
  },
}
</script>

<style lang="scss" scoped>
.pw-bg {
  background-color: #0b0b0b;
}
.x {
  position: absolute;
  background-image: url(https://img.dota2.com.cn/file/6e/a2/6ea2fdef641041481d9eecfedd8c4c431593308825.png);
  background-repeat: no-repeat;
  background-position: 50% 50%;
  cursor: pointer;
  height: 20px;
  width: 20px;
  right: 15px;
  top: 16px;
  z-index: 2;
}
.d-loginframe {
  width: 366px;
  margin: 0 auto;
  position: relative;
}
/deep/.el-dialog {
  background-color: transparent;
  box-shadow: initial;
  width: 100%;
  height: 100%;
  display: table;
  margin: 0 !important;
}
/deep/.el-dialog__header {
  display: none;
}
/deep/.el-dialog__body {
  padding: 0;
  vertical-align: middle;
  display: table-cell;
}
</style>
